import type { FormStructure, FormStateObject } from './Form.types';
import type { ValidationFieldError } from '../validation/Validation.types';

const updateStateObject = (
  name: string,
  value: any,
  form: FormStructure,
  newError: ValidationFieldError,
): FormStateObject => {
  const formCopy = { ...form };
  const { errors, isTouched } = form;
  delete formCopy.errors[name];
  return {
    form: {
      ...formCopy,
      [name]: value,
      errors: { ...errors, [name]: newError[name] },
      isTouched: { ...isTouched, [name]: true },
    },
  };
};

export default updateStateObject;
